export class MarketAccess {
    recordType!: string;
    FirmMPID!: string;
    reportDate!: string;
    symbol!: string;
    orderID!: string;
    routeID!: string;
    OMSOrderID!: string;
    orderQuantity!: number;
    routeQuantity!: number;
    orderPrice!: number;
    routePrice!: number;
    orderAmount!: number;
    routeAmount!: number;
    side!: string;
    destination!: string;
    customer!: string;
    trader!: string;
    bidPrice!: number;
    askPrice!: number;
    routeBidPrice!: number;
    routeAskPrice!: number;
    createDate!: string;
}